<template>
    <div class="button {inline-block;p:10|32;r:100;b:1}>button {b:#6F737D;color:#6F737D}>button.inactive {b:primary;bg:primary;color:white}>button.active">
        <button class="inactive" @click="leave" type="button" v-if="joined">已追蹤</button>
        <button class="active" @click="join" type="button" v-else>追蹤</button>
    </div>
</template>

<script setup>
    const global = useGlobal();

    const props = defineProps({
        following: { default: false, type: Boolean },
        id: { required: true, type: Number }
    });

    const joined = ref(props.following);

    let submited = false;

    const join = () => {
        if (submited) {
            return;
        }
        submited = true;
        api("api/part/join", {
            part_id: props.id
        }).done((res) => {
            if (res.success) {
                joined.value = true;
                global.success("已追蹤趴特");
            }
        }).always(() => {
            submited = false;
        });
    };

    const leave = () => {
        if (submited) {
            return;
        }
        submited = true;
        api("api/part/leave", {
            part_id: props.id
        }).done((res) => {
            if (res.success) {
                joined.value = false;
                global.error("已取消追蹤");
            }
        }).always(() => {
            submited = false;
        });
    };
</script>
